import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {formatDate} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {ServerConfigService} from './server-config.service';
import {Sign} from '../shared/models/sign.model';
import {routeDateFormat} from '../core/constants/route.formats';

const URL_MONTH_INFO = 'getMonthOverview';
const URL_ALL_SIGNS = 'getAllSigns';

export interface MonthDayInformation {
    day: string;
    phase: number;
    signId: string;
}


@Injectable({
    providedIn: 'root'
})
export class MonthService {

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private config: ServerConfigService
    ) {
    }


    getMonthInformation(from: Date, to: Date): Observable<MonthDayInformation[]> {
        const language = this.translate.getCurrentLang();

        const fromDate = formatDate(from, routeDateFormat, 'en');
        const toDate = formatDate(to, routeDateFormat, 'en');

        const requestUrl = `${this.config.getRestUrl()}/${URL_MONTH_INFO}/${fromDate}/${toDate}/${language}`;
        return this.http.get<MonthDayInformation[]>(requestUrl);
    }

    getAllSigns(): Observable<Sign[]> {
        const language = this.translate.getCurrentLang();

        const requestUrl = `${this.config.getRestUrl()}/${URL_ALL_SIGNS}/${language}`;
        return this.http.get<Sign[]>(requestUrl);
    }
    
}
